import { MODAL_TYPE_POST_SETTINGS } from '@wix/communities-blog-client-common';
import { OPEN_MODAL } from '../../modals/framework/store/modal-actions';

const handler = (action) => {
  if (action.payload.type !== MODAL_TYPE_POST_SETTINGS) {
    return;
  }

  return {
    evid: 228,
    eventMeta: {
      isNavigation: false,
      description: 'Advanced post settings open',
    },
    is_published: false,
  };
};

export const uouShowModalEvent = { [OPEN_MODAL]: handler };
